/**
 * How a phone moves from one screen to the next: a screen opened from a list slides in over it, going back
 * slides it away, and moving between the tabs is instant. `isTab` says which screens the tabs open. The class
 * names are drawn in shared/phone/phone.css.
 */
export function slideBetween(from: string, to: string, isTab: (pathname: string) => boolean): "pn-forward" | "pn-back" | "none" {
  const depth = (p: string) => (isTab(p) ? 0 : p.split("/").filter(Boolean).length);
  if (depth(to) > depth(from)) return "pn-forward";
  if (depth(to) < depth(from)) return "pn-back";
  return "none";
}
